/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { ActivityIndicator, Button, Icon } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import connect from "react-redux/es/connect/connect";
import Theme from "../../utils/Theme";
import NavBar from "../../components/NavBar";
import PinInput from "../../components/PinInput";
import * as selectors from "../../selectors";
import * as verificationAction from "../../actions/verification";
import * as authAction from "../../actions/auth";
import { millisecondsToTime } from "../../utils/DateTimeManager";
import * as verificationSelectors from "../../selectors/verification";

const StyledContainer = styled.div`
  background: white;
  position: absolute;
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledAnimatedContainer = styled.div`
  background: white;
  min-height: 100vh;
  max-width: ${Theme.MaxWidth};
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledLeftIconContainer = styled.div`
  padding: 0 0.6em
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const StyledMainContainer = styled.div`
  margin-top: 4.1em;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const StyledTitle = styled.span`
  margin-top: 20%;
  font-size: 1.4em;
  line-height: 2.1em;
  font-weight: 900;
`;

const StyledDescription = styled.span`
  margin-top: 3%;
  color: grey;
  font-size: 0.9em;
  line-height: 1.3em;
`;

const StyledButton = styled(Button)`
  margin-top: 7%;
  width: 100%;
  box-shadow: 0 4px 6px -5px grey;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${props =>
      props.disabled ? "grey" : Theme.PrimaryColor};
  }
`;

const StyledCountdownContainer = styled.div`
  margin-top: 7%;
  display: flex;
  flex-direction: row;
  justify-contnet: center;
  align-items: center;
`;

const StyledErrorMesage = styled.span`
  margin-top: 2%;
  font-size: 0.8em;
  color: red;
  height: 1em;
`;

const StyledStatus = styled.span`
  font-size: 0.8em;
  color: ${Theme.SecondaryColor};
`;

const StyledCountdownBtn = styled.div`
  margin-left: 5px;
  font-weight: bold;
  font-size: 0.9em;
  color: red;
`;

class VerifyMobilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      animationClass: null,
      securityCode: "",
      intervalId: null,
      countdown: 0
    };
  }

  componentDidMount() {
    let intervalId = setInterval(() => {
      const currentTimeStamp = new Date().getTime() / 1000;
      const expiryTimeStamp =
        this.props.verificationItem &&
        this.props.verificationItem.expiry_datetime
          ? this.props.verificationItem.expiry_datetime.timestamp
          : null;
      const countdown = expiryTimeStamp - currentTimeStamp;

      if (countdown > 0) {
        this.setState({ countdown: countdown });
      } else {
        this.setState({ countdown: 0 });
      }
    }, 1000);

    this.setState({ intervalId: intervalId, animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.verifyStatus !== nextProps.verifyStatus) {
      if (nextProps.verifyStatus) {
        this.signUpAccount();
      }
    }
  }

  signUpAccount = () => {
    const { securityCode } = this.state;
    const {
      verificationItem,
      signUpRequest,
      mobileNumber,
      signUpPassword
    } = this.props;
    const token = verificationSelectors.getPhoneVerificationItemToken(
      verificationItem
    );
    const submitData = {
      type: "phone",
      prefix: "+60",
      number: mobileNumber,
      password: signUpPassword,
      confirm_password: signUpPassword,
      token: token,
      secret: securityCode
    };
    signUpRequest(submitData);
  };

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getNavBar = () => {
    return (
      <NavBar
        middleTitle={""}
        leftIcon={
          <StyledLeftIconContainer>
            <Icon type="left" size="xs" />
            <FormattedMessage
              id="app.back"
              defaultMessage="Back"
              description="Navigate to previous page"
            />{" "}
          </StyledLeftIconContainer>
        }
        onLeftIconClick={() => this.onBackPressed()}
        {...this.props}
      />
    );
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onSubmit = () => {
    const { securityCode } = this.state;
    const { verificationItem, verifyPhoneVerificationCodeRequest } = this.props;
    const verificationToken = verificationSelectors.getPhoneVerificationItemToken(
      verificationItem
    );
    const submitData = {
      type: "phone",
      token: verificationToken,
      secret: securityCode
    };

    verifyPhoneVerificationCodeRequest(submitData);
  };

  onResendClicked = () => {
    const { requestPhoneVerificationCodeRequest, mobileNumber } = this.props;

    const requestData = {
      type: "phone",
      prefix: "+60",
      number: mobileNumber
    };

    requestPhoneVerificationCodeRequest(requestData);
  };

  render() {
    const { animationClass, securityCode, countdown, error } = this.state;
    const { verifyLoading, signUpLoading, intl } = this.props;

    return (
      <StyledContainer>
        <ActivityIndicator
          toast
          text={intl.formatMessage({
            id: "app.loading",
            defaultMessage: "Loading..."
          })}
          animating={signUpLoading}
        />
        <StyledAnimatedContainer
          className={animationClass !== null ? animationClass : false}
          onAnimationEnd={() => this.setState({ animationClass: null })}
        >
          {this.getNavBar()}
          <StyledMainContainer>
            <StyledTitle>
              <FormattedMessage
                id="verify.title"
                defaultMessage="Verify Mobile Number"
                description="Verify Mobile Number Title"
              />
            </StyledTitle>
            <StyledDescription>
              <FormattedMessage
                id="verify.description"
                defaultMessage="Please key in the code sent via SMS within the next one minutes, or you will received an automated reminder via phone call."
                description="Verify Mobile Number Description"
              />
            </StyledDescription>
            <PinInput
              length={4}
              type="numeric"
              style={{ marginTop: "10%" }}
              inputStyle={{
                border: "1px solid lightgray",
                fontSize: "1em",
                fontWeight: 900,
                color: "black"
              }}
              inputFocusStyle={{
                borderBottom: "5px solid " + Theme.PrimaryColor
              }}
              onChange={value => this.setState({ securityCode: value })}
            />
            <StyledErrorMesage>{error ? error : ""}</StyledErrorMesage>
            <StyledButton
              disabled={verifyLoading || securityCode.length !== 4}
              loading={verifyLoading}
              activeStyle={{ backgroundColor: Theme.ActivePrimary }}
              onClick={() => this.onSubmit()}
            >
              {verifyLoading ? (
                <FormattedMessage
                  id="app.loading"
                  defaultMessage="Loading"
                  description="Loading Title"
                />
              ) : (
                <FormattedMessage
                  id="app.continue"
                  defaultMessage="Continue"
                  description="Verify Mobile Num Btn Title"
                />
              )}
            </StyledButton>
            <StyledCountdownContainer>
              <StyledStatus>
                {countdown === 0 ? (
                  <FormattedMessage
                    id="verify.resend.didnt.receive"
                    defaultMessage="Did not receive the SMS? "
                    description="Verify Mobile Num No Receive SMS Title"
                  />
                ) : (
                  <FormattedMessage
                    id="verify.resend.countdown"
                    defaultMessage="Resend new code in "
                    description="Verify Mobile Num New Code In Title"
                  />
                )}
              </StyledStatus>
              <StyledCountdownBtn
                className={"underline"}
                onClick={() => this.onResendClicked()}
              >
                {countdown <= 0 ? (
                  <FormattedMessage
                    id="verify.resend.title"
                    defaultMessage="Resend new code"
                    description="Verify Mobile Num Resend New Code Title"
                  />
                ) : (
                  millisecondsToTime(countdown * 1000)
                )}
              </StyledCountdownBtn>
            </StyledCountdownContainer>
          </StyledMainContainer>
        </StyledAnimatedContainer>
      </StyledContainer>
    );
  }
}

VerifyMobilePage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  verifyStatus: PropTypes.bool,
  verificationItem: PropTypes.object,
  signUpPassword: PropTypes.string,
  mobileNumber: PropTypes.string,
  verifyLoading: PropTypes.bool,
  signUpLoading: PropTypes.bool,
  requestPhoneVerificationCodeRequest: PropTypes.func,
  verifyPhoneVerificationCodeRequest: PropTypes.func,
  signUpRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    verifyStatus: selectors.getVerifyStatus(state),
    verificationItem: selectors.getPhoneVerificationItem(state),
    signUpPassword: selectors.getPhoneVerificationPassword(state),
    mobileNumber: selectors.getMobileNumber(state),
    verifyLoading: selectors.getVerifyCodeLoading(state),
    signUpLoading: selectors.getAuthSignUpLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    requestPhoneVerificationCodeRequest: (data, password) =>
      dispatch(
        verificationAction.requestPhoneVerificationCodeRequest(data, password)
      ),
    verifyPhoneVerificationCodeRequest: data =>
      dispatch(verificationAction.verifyPhoneVerificationCodeRequest(data)),
    signUpRequest: data => dispatch(authAction.signUpAccountRequest(data))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VerifyMobilePage)
);



// WEBPACK FOOTER //
// ./src/containers/VerifyMobilePage/index.js